import React, { Component as C } from "react"
import i18n from "@cirrus/legacy/app-common/alt/framework/i18n.js"
import PropTypes from "prop-types"
import classnames from "classnames"
import Link from "@cirrus/legacy/app-components/links/index.jsx"
import Icon from "@cirrus/legacy/app-components/icons/icon/index.jsx"
import Button from "@cirrus/legacy/app-components/buttons/button/index.jsx"
import StatelessTextInput from "@cirrus/legacy/app-components/form-controls/inputs/stateless-text-input/index.jsx"

import styles from "./index.less"

class LabelsFilter extends C {
  static propTypes = {
    buttonDataQa: PropTypes.string,
    className: PropTypes.string,
    search: PropTypes.string,
    onFilterApplied: PropTypes.func,
    onSearchChanged: PropTypes.func,
    onAllSelected: PropTypes.func,
    onAllUnselected: PropTypes.func,
    buttonText: PropTypes.string,
    firstText: PropTypes.string,
    isEmptyItems: PropTypes.bool,
    applyDisabled: PropTypes.bool,
  }

  render() {
    let {
      search,
      onAllSelected,
      onAllUnselected,
      onSearchChanged,
      firstText,
      isEmptyItems,
      applyDisabled,
      onFilterApplied,
      buttonText,
      buttonDataQa,
    } = this.props

    return (
      <div className={classnames(styles.labelListContainer, this.props.className)}>
        <div>
          <div className={styles.firstText}>{firstText}</div>
          <div className={styles.search}>
            <StatelessTextInput
              placeholder={i18n("General:Search")}
              value={search}
              dataQa="labels-search"
              onChange={(e, value) => onSearchChanged(value)}
            />
            <Icon className={styles.searchIcon} icon="fa-search" />
          </div>
          {!isEmptyItems && (
            <div className={styles.actionLinks}>
              <Link className={styles.labelListActionLink} onClick={onAllSelected}>
                {i18n("Library.Labels:SelectAll")}
              </Link>
              <Link className={styles.labelListActionLink} onClick={onAllUnselected}>
                {i18n("Library.Labels:UnSelectAll")}
              </Link>
            </div>
          )}
        </div>

        {this.props.children}

        {!isEmptyItems && (
          <Button
            type="filled-success"
            dataQa={buttonDataQa}
            className={styles.labelListButton}
            disabled={applyDisabled}
            onClick={onFilterApplied}>
            {buttonText ? buttonText : i18n("General.Filter:Filter")}
          </Button>
        )}
      </div>
    )
  }
}

export default LabelsFilter
